import { checkIfDevEnvironment } from './checkIfDevEnvironment';

export const checkDomainIsAdmin = () => {
  const domain = location.href;
  const isDev = checkIfDevEnvironment();
  const devUrl = process.env['NEXT_PUBLIC_ADMIN_URL'] ?? 'http://localhost:3400';
  //Check domain boolean stores information necessary to get proper token
  return isDev ? domain.includes(devUrl) : domain.includes('admin');
};
